import {FormFields} from "@/types";
import {$t} from "@/lib/helpers/i18nHelper";

interface PaymentSystemInfo {
  name: string;
  type: string;
  fields: FormFields;
}

export const paymentSystems: PaymentSystemInfo[] = [
  {
    name: $t("VTB"),
    type: "vtb",
    fields: [
      {
        name: "clientId",
        title: $t("Client ID"),
      },
      {
        name: "clientSecret",
        title: $t("Client Secret"),
      }
    ],
  },
  {
    name: $t("YooKassa"),
    type: "yookassa",
    fields: [
      {
        name: "shopId",
        title: $t("Shop ID"),
      },
      {
        name: "secretKey",
        title: $t("API Secret Key"),
      }
    ],
  },
];

let filteredPaymentSystems = paymentSystems;

export { filteredPaymentSystems };
